import { render } from "./VendorsList.vue?vue&type=template&id=2a781d38&scoped=true"
import script from "./VendorsList.vue?vue&type=script&lang=js"
export * from "./VendorsList.vue?vue&type=script&lang=js"

import "./VendorsList.vue?vue&type=style&index=0&id=2a781d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a781d38"]])

export default __exports__